module.exports = __webpack_public_path__ + "static/media/accountSettings.1392661d.svg";